export const fontSizeTypeToRemNum = {
    small: 1.25,
    medium: 1.5,
    large: 2.1875,
    inherit: null
} as const;
